const _tighter = "-0.05em"
const _tight = "-0.025em"
const _normal = "0em"
const _wide = "0.025em"
const _wider = "0.05em"
const _widest = "0.1em"
const config = { "tighter": _tighter, "tight": _tight, "normal": _normal, "wide": _wide, "wider": _wider, "widest": _widest,  }
export { config as default, _tighter, _tight, _normal, _wide, _wider, _widest }